import { Reaction } from '../../../../generated/graphql';

export const groupReactions = (reactions: Reaction[], num: number) => {
  const arr = [...reactions].sort((a, b) => b.count - a.count);
  return [arr.slice(0, num), arr.slice(num)];
};
